import { Component, computed, input } from '@angular/core';
import { LucideDynamicIcon } from '@lucide/angular';
import { TextDirective, TextWeight } from '../../../typography/text.directive';
import { JoiiIcon } from '../../../icons/lucide/icon';

export type StatusBadgeColor = 'blue' | 'green' | 'red' | 'amber' | 'grey';

@Component({
  selector: 'joii-status-badge',
  styleUrl: './status-badge.component.css',
  template: `
    @if (icon(); as icon) {
      <svg class="status-badge-icon" [lucideIcon]="icon" [size]="16" [strokeWidth]="iconStrokeWidth()" />
    } @else if (showIndicator()) {
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
        <circle cx="4" cy="4" r="4" />
      </svg>
    }
    <span joii-text [size]="3" [weight]="weight()" [color]="fillTextColor() ? 'inherit' : 'base'">
      @if (content()) {
        {{ content() }}
      } @else {
        <ng-content />
      }
    </span>
  `,
  imports: [TextDirective, LucideDynamicIcon],
  host: {
    '[attr.data-color]': 'color()',
    '[attr.fill-text-color]': 'fillTextColor()',
  },
})
export class StatusBadgeComponent {
  color = input<StatusBadgeColor>('blue');
  content = input<string>('Pending');
  icon = input<JoiiIcon>();
  fillTextColor = input<boolean>(false); // If true, the text color will be the same as the icon color
  showIndicator = input<boolean>(true);
  weight = input<TextWeight>('regular');

  readonly iconStrokeWidth = computed(() => {
    switch (this.weight()) {
      case 'semibold':
        return 2.5;
      case 'bold':
      case 'black':
        return 3;
      default:
        return 2;
    }
  });
}
